import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import templatesIcon from "app/images/paywall-body-icon-templates.png";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function PinnedPostsPaywall({ show, onClose }: PropsDef) {
  const { t } = useTranslation();

  const upperContent = (
    <>
      <h5>{t("Posts Pinning Not Enabled")}</h5>
      <p className={styles.description}>
        {t("Upgrade to ")}{" "}
        <a href="https://coachnow.io/pricing" className={styles.highlight}>
          CoachNow PRO
        </a>
        {t(" to pin posts in Spaces and Groups.")}
      </p>
    </>
  );

  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to Pin Posts"
      image={templatesIcon}
      returnUrl="/groups"
      featureName="Pinned Posts"
      upperContent={upperContent}
    />
  );
}
